export const runwayListArray = [
  {
    id: 1,
    pcn: 'RWY 1',
    lightsIntensity: '12L/30R',
    lengthWidth: '11,750 ft x 148ft',
    surfaceType: 'Asphalt',
  },
];

export const surfaceType = [
  { itemValue: '', itemLabel: 'Select...' },
  { itemValue: 'CONCRETE', itemLabel: 'CONCRETE' },
  { itemValue: 'ASPHALT', itemLabel: 'ASPHALT' },
  { itemValue: 'DIRT', itemLabel: 'DIRT' },
  { itemValue: 'GRAVEL', itemLabel: 'GRAVEL' },
  { itemValue: 'TURF', itemLabel: 'TURF' },
  { itemValue: 'WATER', itemLabel: 'WATER' },
  { itemValue: 'SNOW', itemLabel: 'SNOW' },
  { itemValue: 'ICE', itemLabel: 'ICE' },
  { itemValue: 'MATS', itemLabel: 'MATS' },
  { itemValue: 'TREATED', itemLabel: 'TREATED' },
  { itemValue: 'UNKNOWN', itemLabel: 'UNKNOWN' },
];

export const lightsIntensity = [
  { itemValue: '', itemLabel: 'Select...' },
  { itemValue: 'HIGH', itemLabel: 'HIGH' },
  { itemValue: 'MEDIUM', itemLabel: 'MEDIUM' },
  { itemValue: 'LOW', itemLabel: 'LOW' },
  { itemValue: 'NONE', itemLabel: 'NONE' },
  { itemValue: 'NONSTD', itemLabel: 'NONSTD' },
];

export const alignment = [
  { itemValue: '', itemLabel: 'NULL' },
  { itemValue: 'L', itemLabel: 'L' },
  { itemValue: 'C', itemLabel: 'C' },
  { itemValue: 'R', itemLabel: 'R' },
];

export const approachLightingSystem = [
  { itemValue: '', itemLabel: 'Select...' },
  // { itemValue: 'ALSAF', itemLabel: 'ALSAF' },
  { itemValue: 'ALSF-I', itemLabel: 'ALSF-I' },
  { itemValue: 'ALSF-II', itemLabel: 'ALSF-II' },
  { itemValue: 'MALSR/SSALR', itemLabel: 'MALSR/SSALR' },
  { itemValue: 'MALS/MALSF', itemLabel: 'MALS/MALSF' },
  { itemValue: 'SALS', itemLabel: 'SALS' },
  { itemValue: 'SALSF', itemLabel: 'SALSF' },
  { itemValue: 'SSALF/SSALS', itemLabel: 'SSALF/SSALS' },
  { itemValue: 'ODALS', itemLabel: 'ODALS' },
  { itemValue: 'HIALS', itemLabel: 'HIALS' },
  { itemValue: 'HALS', itemLabel: 'HALS' },
  { itemValue: 'LDIN/RLLS', itemLabel: 'LDIN/RLLS' },
  { itemValue: 'NATO', itemLabel: 'NATO' },
  { itemValue: 'CALVERT I', itemLabel: 'CALVERT I' },
  { itemValue: 'CALVERT II', itemLabel: 'CALVERT II' },
  { itemValue: 'PALS', itemLabel: 'PALS' },
  // { itemValue: 'NEON', itemLabel: 'NEON' },
  // { itemValue: 'MIL OVRN', itemLabel: 'MIL OVRN' },
  // { itemValue: 'NSTD', itemLabel: 'NSTD' },
  { itemValue: 'NONE', itemLabel: 'NONE' },
];

export const visualGlideSlope = [
  { itemValue: '', itemLabel: 'Select...' },
  { itemValue: 'S2L', itemLabel: '2-Light Simplified VASI on left' },
  { itemValue: 'S2R', itemLabel: '2-Light Simplified VASI on right ' },
  { itemValue: 'V2L', itemLabel: '2-Light VASI on left' },
  { itemValue: 'V2R', itemLabel: '2-Light VASI on right' },
  { itemValue: 'V4L', itemLabel: '4-Light VASI on left' },
  { itemValue: 'V4R', itemLabel: '4-Light VASI on right' },
  { itemValue: 'V6L', itemLabel: '6-Light VASI on left' },
  { itemValue: 'V6R', itemLabel: '6-Light VASI on right' },
  { itemValue: 'V12', itemLabel: '12-Light VASI on both sides' },
  { itemValue: 'V16', itemLabel: '16-Light VASI on both sides' },
  { itemValue: 'P2L', itemLabel: '2-Light PAPI on left' },
  { itemValue: 'P2R', itemLabel: '2-Light PAPI on right' },
  { itemValue: 'P2B', itemLabel: '2-Light PAPI on both sides' },
  { itemValue: 'P4L', itemLabel: '4-Light PAPI on left' },
  { itemValue: 'P4R', itemLabel: '4-Light PAPI on right' },
  { itemValue: 'P4B', itemLabel: '4-Light PAPI on both sides' },
  { itemValue: 'NSTD', itemLabel: 'Non Standard VASI' },
  { itemValue: 'PVT', itemLabel: 'Privately owned indicator' },
  { itemValue: 'VAS', itemLabel: 'Non-specific VASI system' },
  { itemValue: 'NONE', itemLabel: 'No Approach slope system' },
  { itemValue: 'TRIL', itemLabel: 'Tri-Color VASI left side' },
  { itemValue: 'TRIR', itemLabel: 'Tri-Color VASI right side' },
  { itemValue: 'PSIL', itemLabel: 'Pulsating/Steady VASI left side' },
  { itemValue: 'PSIR', itemLabel: 'Pulsating/Steady VASI right side' },
  { itemValue: 'PNIL', itemLabel: 'Unknown Panels on left side' },
  { itemValue: 'PNIR', itemLabel: 'Unknown Panels on right side' },
];

export const aircraftArrestingDevice = [
  { itemValue: 'NONE', itemLabel: 'NONE' },
  { itemValue: 'BAK-6', itemLabel: 'BAK-6' },
  { itemValue: 'BAK-9', itemLabel: 'BAK-9' },
  { itemValue: 'BAK-12', itemLabel: 'BAK-12' },
  { itemValue: 'BAK-12B', itemLabel: 'BAK-12B' },
  { itemValue: 'BAK-13', itemLabel: 'BAK-13' },
  { itemValue: 'BAK-14', itemLabel: 'BAK-14' },
  { itemValue: 'E5', itemLabel: 'E5' },
  { itemValue: 'E5-1', itemLabel: 'E5-1' },
  { itemValue: 'E27', itemLabel: 'E27' },
  { itemValue: 'E27B', itemLabel: 'E27B' },
  { itemValue: 'E28', itemLabel: 'E28' },
  { itemValue: 'E28B', itemLabel: 'E28B' },
  { itemValue: 'EMAS', itemLabel: 'EMAS' },
  { itemValue: 'M21', itemLabel: 'M21' },
  { itemValue: 'MA-1', itemLabel: 'MA-1' },
  { itemValue: 'MA-1A', itemLabel: 'MA-1A' },
  { itemValue: 'MA-1A MOD', itemLabel: 'MA-1A MOD' },
];
